import {appendQueryString, getCookie, IQuery} from "@pg-mono/request";

export const createLinkWithCrossSiteTracking = (link: string, currentQuery: IQuery = {}) => {
    if (typeof window === "undefined") {
        return link;
    }

    const newQuery = {...currentQuery};
    const gaCookie = getCookie("_ga");

    if (gaCookie) {
        newQuery["_ga"] = gaCookie;
    }

    return appendQueryString(link, newQuery);
};
import {appendQueryString, getCookie, IQuery} from "@pg-mono/request";

export const createLinkWithCrossSiteTracking = (link: string, currentQuery: IQuery = {}) => {
    if (typeof window === "undefined") {
        return link;
    }

    const newQuery = {...currentQuery};
    const gaCookie = getCookie("_ga");

    if (gaCookie) {
        newQuery["_ga"] = gaCookie;
    }

    return appendQueryString(link, newQuery);
};
